import zeusDarkIcon from './assets/dark/ERP.svg'
import zeusBiIcon from './assets/shared/ZEREPORTES.png'
import zeVendorIcon from './assets/shared/ZEVEN.svg'
import zeusBiDarkIcon from './assets/dark/ZEREPORTES.png'
import zeVendorDarkIcon from './assets/dark/ZEVEN.svg'
import zeusLightIcon from './assets/light/ZEUSERP.svg'
import antionDarkIcon from './assets/dark/antion.png'
import tabbiDarkIcon from './assets/dark/tabbi.png'
import zePickDarkIcon from './assets/dark/ZEPICK.svg'
import oulisDarkIcon from './assets/dark/oulis.png'
import yaxDarkIcon from './assets/dark/yax.png'
import antionLightIcon from './assets/light/antion.png'
import tabbiLightIcon from './assets/light/tabbi.png'
import zePickLightIcon from './assets/light/ZEPICK.svg'
import oulisLightIcon from './assets/light/oulis.png'
import yaxLightIcon from './assets/light/yax.png'
import zeCheckDarkIcon from './assets/dark/ZECHEK.svg'
import zeHubDarkIcon from './assets/dark/ZEHUB.svg'
import zeScanDarkIcon from './assets/dark/ZESCAN.svg'
import zeCheckLightIcon from './assets/light/ZECHEK.svg'
import zeHubLightIcon from './assets/light/ZEHUB.svg'
import zeScanLightIcon from './assets/light/ZESCAN.svg'

// Artwork metadata only. Presence here never grants access to an application.
export const APP_LAUNCHER_MANIFEST = {
  ANTION: { label: 'ANTION', icon: { light: antionLightIcon, dark: antionDarkIcon } },
  TABBI: { label: 'TABBI', icon: { light: tabbiLightIcon, dark: tabbiDarkIcon } },
  ZEPICK: { label: 'ZEPICK', icon: { light: zePickLightIcon, dark: zePickDarkIcon } },
  OULIS: { label: 'OULIS', icon: { light: oulisLightIcon, dark: oulisDarkIcon } },
  YAX: { label: 'YAX', icon: { light: yaxLightIcon, dark: yaxDarkIcon } },
  ZEUS: { label: 'ZEUS', icon: { light: zeusLightIcon, dark: zeusDarkIcon } },
  ZEUSBI: { label: 'ZE-Reportes', icon: { light: zeusBiIcon, dark: zeusBiDarkIcon } },
  ZEREPORTES: { label: 'ZE-Reportes', icon: { light: zeusBiIcon, dark: zeusBiDarkIcon } },
  ZEHUB: { label: 'ZEHub', icon: { light: zeHubLightIcon, dark: zeHubDarkIcon } },
  ZESCAN: { label: 'ZEScan', icon: { light: zeScanLightIcon, dark: zeScanDarkIcon } },
  ZECHECK: { label: 'ZECheck', icon: { light: zeCheckLightIcon, dark: zeCheckDarkIcon } },
  ZEVENDOR: { label: 'ZEVendor', icon: { light: zeVendorIcon, dark: zeVendorDarkIcon } },
}
